<template lang="pug">
v-layout
  //-POPUP-ALERT
  PopupAlertMessage(
    @closeAlertPopup="actionPopupMethod($event, popupAlert.option)"
    :openPopup="popupAlert.openPopup"
    :image="popupAlert.image"
    :title="popupAlert.title"
    :message="popupAlert.message"
    :messageButton="popupAlert.messageButton"
    :buttonClose="popupAlert.buttonClose"
    :imgHeight="popupAlert.imgHeight"
    :imgWidth="popupAlert.imgWidth"
      )
  //- LOADER PROCESS
  v-dialog(v-model="loader.flag" persistent width="300")
    v-card(color="primary" dark="")
      v-card-text
        | {{loader.text}}
        v-progress-linear.mb-0(indeterminate="" color="white")
  v-dialog(v-model="openPopup" fullscreen hide-overlay persistent transition='dialog-bottom-transition')
    v-card.box-card-mis-solicitudes-formatter
      v-toolbar(dark color='primary')
        v-btn.btn-backspace(outline flat fab small @click="methodClosePopup")
          v-icon keyboard_backspace
        v-toolbar-title
          span(style="color: #ffffff; font-size: 20px;") {{ titleText }}
      v-card-text.box-card-text-mis-solicitudes(style="padding: 2em 1em;")
        v-layout(v-if="flagSolicitudesDisponibles" column align-center)
          v-flex.mb-4.mx-3(v-if="poliza.nombreProducto != 'VIDAFREE'" )
            span(style="color: #454A6C;font-size:18px;line-height:18px") Estas son las solicitudes que puedes realizar
          v-flex
            v-layout(row wrap style="width: 24em;")
              v-flex.box-tarjetas-mis-solicitudes(xs6 v-if="flagTarjetas.modificacionBeneficiario")
                CardMisSolicitudes2(
                  @cardMethod="modificarBeneficiariosMethod"
                  :text="'Modificación de Beneficiarios'"
                  :icon="iconMisBeneficiarios"
                  :icon2="iconMisBeneficiarios2"
                  :floatingText="'Nuevo'"
                  :activo="flagTarjetas.modificacionBeneficiario"
                  )
              v-flex.box-tarjetas-mis-solicitudes(xs6 v-if="flagTarjetas.cuotaComodin")
                CardMisSolicitudes2(
                  @cardMethod="cuotaComodinMethod"
                  :text="'Cuota Comodín'"
                  :icon="iconCuotaComodin"
                  :icon2="iconCuotaComodin2"
                  :activo="flagTarjetas.cuotaComodin"
                  )
              v-flex.box-tarjetas-mis-solicitudes(xs6 v-if="flagTarjetas.endosoEntidadFinanciera")
                CardMisSolicitudes2(
                  @cardMethod="endosoMethod"
                  :text="'Endoso a entidad financiera'"
                  :icon="iconEndoso"
                  :icon2="iconEndoso2"
                  :activo="flagTarjetas.endosoEntidadFinanciera"
                  )
              v-flex.box-tarjetas-mis-solicitudes(xs6 v-if="flagTarjetas.liberacionEndoso")
                CardMisSolicitudes2(
                  @cardMethod="liberacionEndosoMethod"
                  :text="'Liberación de endoso'"
                  :icon="iconLiberacion"
                  :icon2="iconLiberacion2"
                  :activo="flagTarjetas.liberacionEndoso"
                  )
              v-flex.box-tarjetas-mis-solicitudes(xs6 v-if="flagTarjetas.anulacionPoliza")
                CardMisSolicitudes2(
                  @cardMethod="anulacionPolizaMethod"
                  :text="'Anulación de póliza'"
                  :icon="iconAnulacion"
                  :icon2="iconAnulacion2"
                  :activo="flagTarjetas.anulacionPoliza"
                  )
              v-flex.box-tarjetas-mis-solicitudes(xs6)
                CardMisSolicitudes2(
                  @cardMethod="seguimientoSolicitudMethod"
                  :text="'Seguimiento de solicitudes'"
                  :icon="iconSeguimiento"
                  :icon2="iconSeguimiento3"
                  :activo="flagTarjetas.seguimientoSolicitud"
                  )
              v-flex.box-tarjetas-mis-solicitudes(xs6 v-if="flagTarjetas.cambioFrecuenciaPago")
                CardMisSolicitudes2(
                  @cardMethod="cambioFrecuenciaPagoMethod"
                  :text="'Cambio frecuencia de pago'"
                  :icon="iconFrecuencia"
                  :icon2="iconFrecuencia2"
                  :floatingText="'Nuevo'"
                  :activo="flagTarjetas.cambioFrecuenciaPago"
                  )
              v-flex.box-tarjetas-mis-solicitudes(xs6 v-if="flagTarjetas.eliminacionCobertura")
                CardMisSolicitudes2(
                  @cardMethod="eliminacionCoberturaMethod"
                  :text="'Eliminación de cobertura'"
                  :icon="iconEliminarCobertura"
                  :icon2="iconEliminarCobertura2"
                  :floatingText="'Nuevo'"
                  :activo="flagTarjetas.eliminacionCobertura"
                  )
        v-layout(v-if="flagTrackingSolicitudes" column align-center)
          v-layout(row wrap style="justify-content: space-between; margin-bottom: 26px; width: 90%")
            .btn-solicitudes-estado(
              v-for="(estado, index) in estados" :key="index"
              :class="{'btn-solicitudes-estado-seleccionado' : estado.seleccionado, 'disabled': requerimientos.length === 0}"
              @click="cambiarFiltroEstado(estado.nombre)"
            )
              span {{ estado.nombre }}
          v-flex.mb-4.mx-3(v-if="requerimientos.length > 0")
            span(style="color: #454A6C;font-size:18px;line-height:18px") Elige la solicitud que deseas visualizar.
          v-flex
            CardTrackingSolicitudes(
              v-for="(req, index) in requerimientosFiltrados" :key="req.id"
              :title="req.title"
              :code="req.code"
              :percent="req.percent"
              :selected="req.selected"
              :status="req.status"
              :requirement="req.requirement"
              style="width: 315px"
              dispositivo="mobile"
            )
            v-layout(v-if="requerimientos.length === 0" column wrap style="justify-content: space-between;margin-top: 80px;align-items: center;")
              v-img
                img(:src="iconNoRequirements")
              p(style="margin-top: 25px; text-align: center;") Aquí se mostrarán las solicitudes que
                br
                | hayas creado.
      v-card-actions
        v-layout(column align-center)
          v-flex
            span(style="font-size: 18px;color: #0855C4;" @click="methodClosePopup")
              b Volver
</template>

<script>
import CardMisSolicitudes2 from './CardMisSolicitudes2.vue'
import PopupAlertMessage from '../PopupAlertMessage.vue'
import CardTrackingSolicitudes from './CardTrackingSolicitudes.vue'
import {mapActions, mapGetters} from 'vuex'
import Functionalities from '../../interfaces/functionalities'

export default {
  props: [
    'openPopup',
    'mas2Anhos',
    'puedeEndosar',
    'puedeCuotaComodin',
    'puedeCambiarFrecuencia',
    'puedeLiberarEndoso',
    'puedeCambiarBeneficiario',
    'puedeRetirarCoberturas',
    'poliza',
    'taggeo',
    'solicitudBeneficiarios',
    'solicitudComodin',
    'solicitudEndosoEntidadFinanciera',
    'solicitudLiberacionEndoso',
    'solicitudAnulacion',
    'solicitudSeguimiento',
    'action'
  ],
  data () {
    return {
      titleText: 'Mis solicitudes',
      flagSolicitudesDisponibles: true,
      flagTrackingSolicitudes: false,
      iconMisBeneficiarios: require('./../../assets/icons-mis-seguros/icon-modificacion-beneficiarios.png'),
      iconMisBeneficiarios2: require('./../../assets/icons-mis-seguros/icon-modificacion-beneficiarios2.png'),
      iconCuotaComodin: require('./../../assets/icons-mis-seguros/icon-cuota-comodin.png'),
      iconCuotaComodin2: require('./../../assets/icons-mis-seguros/icon-cuota-comodin2.png'),
      iconEndoso: require('./../../assets/icons-mis-seguros/icon-endoso-entidad-financiera.png'),
      iconEndoso2: require('./../../assets/icons-mis-seguros/icon-endoso-entidad-financiera2.png'),
      iconLiberacion: require('./../../assets/icons-mis-seguros/icon-liberacion-endoso.png'),
      iconLiberacion2: require('./../../assets/icons-mis-seguros/icon-liberacion-endoso2.png'),
      iconAnulacion: require('./../../assets/icons-mis-seguros/icon-anulacion-poliza.png'),
      iconAnulacion2: require('./../../assets/icons-mis-seguros/icon-anulacion-poliza2.png'),
      iconSeguimiento: require('./../../assets/icons-mis-seguros/icon-seguimiento-mis-solicitudes.png'),
      iconSeguimiento2: require('./../../assets/icons-mis-seguros/icon-seguimiento-mis-solicitudes2.png'),
      iconSeguimiento3: require('./../../assets/icons-mis-seguros/icon-seguimiento-mis-solicitudes3.png'),
      iconFrecuencia: require('./../../assets/icons-mis-seguros/icon-cambio-frecuencia-pago.svg'),
      iconFrecuencia2: require('./../../assets/icons-mis-seguros/icon-cambio-frecuencia-pago2.svg'),
      iconEliminarCobertura: require('./../../assets/icons-mis-seguros/icon-eliminar-cobertura.png'),
      iconEliminarCobertura2: require('./../../assets/icons-mis-seguros/icon-eliminar-cobertura2.png'),
      iconPopupInfo: require('@/assets/characters/informa.svg'),
      iconPopupContruccion: require('./../../assets/icons/icon-construccon.svg'),
      iconNoRequirements: require('./../../assets/icons/icon-information-girl.svg'),
      flagSolicitudes: false,
      loader: {
        flag: false,
        text: ''
      },
      mensaje1: 'Te redireccionaremos a la solicitud ',
      mensaje2: 'En estos momentos no puede realizar esta solicitud',
      mensaje3: 'Está solicitud no está disponible para ti, revisa las condiciones de tu seguro.',
      flagTarjetas: {
        modificacionBeneficiario: false,
        cuotaComodin: false,
        endosoEntidadFinanciera: false,
        liberacionEndoso: false,
        anulacionPoliza: false,
        seguimientoSolicitud: true,
        cambioFrecuenciaPago: false,
        eliminacionCobertura: false
      },
      popupAlert: {
        openPopup: false,
        option: '',
        image: null,
        title: 'Estimado cliente',
        message: '',
        messageButton: 'Entendido',
        buttonClose: false,
        imgHeight: 150,
        imgWidth: 150
      },
      requerimientos: [],
      requerimientosFiltrados: [],
      estados: [
        { nombre: 'Creado', seleccionado: true },
        { nombre: 'En curso', seleccionado: false },
        { nombre: 'Finalizado', seleccionado: false }
      ]

    }
  },
  methods: {
    ...mapActions('requirements', ['getAllRequirementsPerPolicy']),
    ...mapActions('event', ['eventLog']),
    methodClosePopup () {
      this.$emit('closePopup', '')
    },
    modificarBeneficiariosMethod () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.VIMDB, self.functionsRules, self)) {
        return
      }
      // let auxMensaje = this.flagTarjetas.modificacionBeneficiario ? this.mensaje2 : this.mensaje3
      this.popupAlert.openPopup = true
      this.popupAlert.option = 'beneficiarios'
      this.popupAlert.image = this.iconPopupInfo
      this.popupAlert.messageButton = 'Entendido'
      this.popupAlert.buttonClose = this.puedeCambiarBeneficiario

      let auxSolicitudes = this.solicitudBeneficiarios
      let solicitud = auxSolicitudes.pop()

      if (this.puedeCambiarBeneficiario) {
        if (!solicitud || solicitud.state === 'ERROR' || solicitud.state === 'ATENDIDO' ||
          solicitud.state === 'PROCESADO' || solicitud.state === 'PROCESADO RPA' ||
          solicitud.state === 'CONFORME' || solicitud.state === 'RECHAZADO') {
          this.popupAlert.message = this.mensaje1 + 'Modificación de Beneficiarios...'
          this.popupAlert.title = 'Estimado cliente'
        } else if (solicitud.state === 'PENDIENTE') {
          this.popupAlert.title = '¡Estamos atendiendo tu solicitud!'
          this.popupAlert.message = 'Podrás modificar tus beneficiarios luego de que tu solicitud sea aprobada.'
        }
      } else {
        this.popupAlert.title = 'Estimado cliente'
        this.popupAlert.message = this.mensaje2
      }
    },
    cambioFrecuenciaPagoMethod () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.VICFP, self.functionsRules, self)) {
        return
      }
      self.popupAlert.openPopup = true
      self.popupAlert.option = 'cambioFrecuencia'
      self.popupAlert.image = self.iconPopupInfo
      self.popupAlert.messageButton = 'Entendido'
      self.popupAlert.buttonClose = true
      self.popupAlert.message = self.mensaje1 + 'Cambio de frecuencia de pago.'
    },
    cuotaComodinMethod () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.VICCM, self.functionsRules, self)) {
        return
      }
      const auxMensaje = this.mensaje2
      this.popupAlert.openPopup = true
      this.popupAlert.option = 'comodin'
      this.popupAlert.image = this.iconPopupInfo
      this.popupAlert.title = 'Estimado cliente'
      this.popupAlert.message = this.puedeCuotaComodin ? this.mensaje1 + 'Cuota Comodín' : auxMensaje
      this.popupAlert.messageButton = 'Entendido'
      this.popupAlert.buttonClose = this.puedeCuotaComodin

      let auxSolicitudes = this.solicitudComodin
      let solicitud = auxSolicitudes.pop()

      if (this.puedeCuotaComodin) {
        if (!solicitud || solicitud.state === 'ERROR' || solicitud.state === 'ATENDIDO' ||
          solicitud.state === 'PROCESADO' || solicitud.state === 'PROCESADO RPA' ||
          solicitud.state === 'CONFORME' || solicitud.state === 'RECHAZADO') {
          this.popupAlert.message = this.mensaje1 + 'Cuota Comodín.'
        } else if (solicitud.state === 'PENDIENTE') {
          this.popupAlert.title = '¡Estamos atendiendo tu solicitud!'
          this.popupAlert.message = 'Podrás realizar una nueva solicitud luego de que la anterior sea aprobada.'
        }
      } else {
        this.popupAlert.title = 'Estimado cliente'
        this.popupAlert.message = this.mensaje2
      }
    },
    endosoMethod () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.VIEEF, self.functionsRules, self)) {
        return
      }
      const auxMensaje = this.mensaje2
      this.popupAlert.openPopup = true
      this.popupAlert.option = 'endoso'
      this.popupAlert.image = this.iconPopupInfo
      this.popupAlert.title = 'Estimado cliente'
      this.popupAlert.message = this.puedeEndosar ? this.mensaje1 + 'Endoso a entidad financiera' : auxMensaje
      this.popupAlert.messageButton = 'Entendido'
      this.popupAlert.buttonClose = this.puedeEndosar

      let auxSolicitudes = this.solicitudEndosoEntidadFinanciera
      let solicitud = auxSolicitudes.pop()

      if (this.puedeEndosar) {
        if (!solicitud || solicitud.state === 'ERROR' || solicitud.state === 'ATENDIDO' ||
          solicitud.state === 'PROCESADO' || solicitud.state === 'PROCESADO RPA' ||
          solicitud.state === 'CONFORME' || solicitud.state === 'RECHAZADO') {
          this.popupAlert.message = this.mensaje1 + 'Endoso a entidad financiera.'
        } else if (solicitud.state === 'PENDIENTE') {
          this.popupAlert.title = '¡Estamos atendiendo tu solicitud!'
          this.popupAlert.message = 'Podrás realizar una nueva solicitud luego de que la anterior sea aprobada.'
        }
      } else {
        this.popupAlert.title = 'Estimado cliente'
        this.popupAlert.message = this.mensaje2
      }
    },
    liberacionEndosoMethod () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.VILE, self.functionsRules, self)) {
        return
      }
      this.popupAlert.openPopup = true
      this.popupAlert.title = 'Estimado cliente'
      this.popupAlert.option = 'liberacion'
      this.popupAlert.image = this.iconPopupInfo
      this.popupAlert.messageButton = 'Entendido'
      this.popupAlert.buttonClose = this.puedeLiberarEndoso

      let auxSolicitudes = this.solicitudLiberacionEndoso
      let solicitud = auxSolicitudes.pop()

      if (this.puedeLiberarEndoso) {
        if (!solicitud || solicitud.state === 'ERROR' || solicitud.state === 'ATENDIDO' ||
          solicitud.state === 'PROCESADO' || solicitud.state === 'PROCESADO RPA' ||
          solicitud.state === 'CONFORME' || solicitud.state === 'RECHAZADO') {
          this.popupAlert.message = this.mensaje1 + 'Liberación de Endoso.'
        } else if (solicitud.state === 'PENDIENTE') {
          this.popupAlert.title = '¡Estamos atendiendo tu solicitud!'
          this.popupAlert.message = 'Podrás realizar una nueva solicitud luego de que la anterior sea aprobada.'
        }
      } else {
        this.popupAlert.title = 'Estimado cliente'
        this.popupAlert.message = this.mensaje2
      }
    },
    anulacionPolizaMethod () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.VIADP, self.functionsRules, self)) {
        return
      }
      // let auxMensaje = this.flagTarjetas.anulacionPoliza ? this.mensaje2 : this.mensaje3
      this.popupAlert.openPopup = true
      this.popupAlert.option = 'anulacion'
      this.popupAlert.image = this.iconPopupInfo
      this.popupAlert.title = 'Estimado cliente'
      // this.popupAlert.message = auxMensaje
      this.popupAlert.messageButton = 'Entendido'
      this.popupAlert.buttonClose = true
      this.popupAlert.message = this.mensaje1 + 'Anulación de póliza.'
    },
    seguimientoSolicitudMethod () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.SEGUIMIENTO, self.functionsRules, self)) {
        return
      }
      this.flagSolicitudesDisponibles = false
      this.flagTrackingSolicitudes = true
      this.titleText = 'Seguimiento de solicitudes'
    },
    eliminacionCoberturaMethod () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.VIRCA, self.functionsRules, self)) {
        return
      }
      self.popupAlert.openPopup = true
      self.popupAlert.option = 'retiroCoberturas'
      self.popupAlert.image = self.iconPopupInfo
      self.popupAlert.messageButton = 'Entendido'
      self.popupAlert.buttonClose = true
      self.popupAlert.message = self.mensaje1 + 'Eliminación de cobertura.'
    },
    actionPopupMethod (action, option) {
      if (option === 'beneficiarios' && action && this.puedeCambiarBeneficiario) {
        this.loader.flag = true
        this.loader.text = 'Vamos a Modificación de Beneficiarios...'

        this.$router.push({ name: 'PerfilBeneficiarios',
          params: {
            policy: this.poliza.numeroPoliza,
            productName: this.poliza.producto,
            producto: this.poliza.ramo,
            subProducto: this.poliza.nombreProducto
          }
        })
          .then(data => {
            this.loader.flag = false
            this.popupAlert.openPopup = false
          }).catch(() => {
            this.popupAlert.openPopup = true
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.message = 'No hemos logrado ir a Modificación de Beneficiarios. Por favor, volver a intentarlo en unos minutos o comunicarse con nuestro Servicio de Atención al Cliente.'
            this.popupAlert.messageButton = 'Entendido'
            this.popupAlert.option = ''
            this.popupAlert.buttonClose = false

            this.loader.flag = false
          })
      } else if (option === 'comodin' && action) {
        this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: 'VICCM', seguroPolicy: this.poliza.numeroPoliza } })
      } else if (option === 'endoso' && action) {
        this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: 'VIEEF', seguroPolicy: this.poliza.numeroPoliza } })
      } else if (option === 'liberacion' && action) {
        this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: 'VILE', seguroPolicy: this.poliza.numeroPoliza } })
      } else if (option === 'anulacion' && action) {
        this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: 'VIADP', seguroPolicy: this.poliza.numeroPoliza } })
      } else if (option === 'seguimiento' && action) {
      } else if (option === 'cambioFrecuencia' && action) {
        this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: 'VICFP', seguroPolicy: this.poliza.numeroPoliza } })
      } else if (option === 'retiroCoberturas' && action) {
        this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: 'VIRCA', seguroPolicy: this.poliza.numeroPoliza } })
      }
      this.popupAlert.openPopup = false
    },
    closeAlertMethod () {
      this.popupAlert.openPopup = false
    },
    cambiarFiltroEstado (estado) {
      this.requerimientosFiltrados = this.requerimientos.filter(req => req.status === estado)
      if (this.requerimientos.length === 0) {
        return
      }
      this.estados = this.estados.map(s => {
        s.seleccionado = s.nombre === estado
        return s
      })
    }
  },
  computed: {
    ...mapGetters('user', ['functionsRules'])
  },
  mounted () {
    let self = this
    if (this.action) {
      this.seguimientoSolicitudMethod()
    }

    const metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Mis solicitudes', metadata})

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'mobile',
        'seccion': 'mis solicititudes'
      }
    })
    // SEGUIMIENTO SOLICITUDES
    self.getAllRequirementsPerPolicy({ numeroPoliza: self.poliza.numeroPoliza })
      .then(res => {
        let statusFilter = 'Creado'
        self.flagSolicitudes = res.data.data.length > 0
        self.solicitudes = res.data.data
        this.requerimientos = res.data.data.map(req => {
          let percent = '10'
          let status = 'Creado'
          if (req.state != null && req.state.includes('PENDIENTE')) {
            const ms = new Date().getTime() - new Date(req.created_at).getTime
            if (ms > 60000) {
              percent = '20'
              status = 'En curso'
            }
          } else if (req.state != null && req.state.includes('ERROR') && req.state.includes('RPA')) {
            percent = '50'
            status = 'En curso'
          } else if (req.state != null && req.state.includes('PROCESADO') && !req.state.includes('RPA')) {
            percent = '100'
            status = 'Finalizado'
          } else if (req.state != null && (req.state.includes('ERROR') || req.state.includes('ATENDIDO') || req.state.includes('PROCESADO RPA') || req.state.toUpperCase().includes('CONFORME') || req.state.includes('RECHAZADO'))) {
            percent = req.state.includes('ERROR') ? '80' : '100'
            status = req.state.includes('ERROR') ? 'En curso' : 'Finalizado'
          }
          let selected = false
          if (this.action && this.action.data.id === req.id) {
            selected = true
            statusFilter = status
          }
          return {
            id: req.id,
            title: req.transact,
            code: req.num_code,
            percent: percent,
            status: status,
            selected,
            requirement: req
          }
        })

        if (this.action && this.action.data.id) {
          this.cambiarFiltroEstado(statusFilter)
        } else {
          this.requerimientosFiltrados = this.requerimientos.filter(req => req.status === statusFilter)
          if (statusFilter !== 'Creado' && this.requerimientosFiltrados.length === 0) {
            statusFilter = 'Creado'
            this.cambiarFiltroEstado(statusFilter)
          }
          if (statusFilter !== 'En curso' && this.requerimientosFiltrados.length === 0) {
            statusFilter = 'En curso'
            this.cambiarFiltroEstado(statusFilter)
          }
          if (statusFilter !== 'Finalizado' && this.requerimientosFiltrados.length === 0) {
            statusFilter = 'Finalizado'
            this.cambiarFiltroEstado(statusFilter)
          }
        }
      }).catch(() => {
        self.popupAlert.openPopup = true
        self.popupAlert.title = 'Estimado cliente'
        self.popupAlert.image = self.iconPopupInfo
        self.popupAlert.message = 'No hemos logrado obtener la información solicitada. Por favor, volver a intentarlo en unos minutos.'
        self.popupAlert.messageButton = 'Entendido'
        self.popupAlert.buttonClose = false
      })

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'mobile',
        'seccion': 'mis solicitudes'
      }
    })

    // VALIDAR - SOLICITUD POR TIPO POLIZA

    if (self.poliza.nombreProducto === 'EDUCACIONGARANTIZADA') {
      self.flagTarjetas.modificacionBeneficiario = true && self.puedeCambiarBeneficiario
      self.flagTarjetas.cuotaComodin = true && self.puedeCuotaComodin && self.mas2Anhos
    } else if (self.poliza.nombreProducto === 'PLANGARANTIZADO') {
      self.flagTarjetas.modificacionBeneficiario = true && self.puedeCambiarBeneficiario
      self.flagTarjetas.cuotaComodin = true && self.puedeCuotaComodin && self.mas2Anhos
      self.flagTarjetas.endosoEntidadFinanciera = true && self.puedeEndosar
      self.flagTarjetas.liberacionEndoso = true && self.puedeLiberarEndoso
    } else if (self.poliza.nombreProducto.includes('VIDACASH')) {
      self.flagTarjetas.modificacionBeneficiario = true && self.puedeCambiarBeneficiario
      self.flagTarjetas.anulacionPoliza = true
    } else {
      self.flagTarjetas.modificacionBeneficiario = true && self.puedeCambiarBeneficiario
      self.flagTarjetas.cuotaComodin = true && self.puedeCuotaComodin && self.mas2Anhos
      self.flagTarjetas.endosoEntidadFinanciera = true && self.puedeEndosar
      self.flagTarjetas.liberacionEndoso = true && self.puedeLiberarEndoso
    }
    self.flagTarjetas.cambioFrecuenciaPago = self.puedeCambiarFrecuencia
    self.flagTarjetas.eliminacionCobertura = self.puedeRetirarCoberturas
  },

  components: {
    CardMisSolicitudes2,
    PopupAlertMessage,
    CardTrackingSolicitudes
  }

}
</script>

<style scoped>
.box-tarjetas-mis-solicitudes {
  max-width: fit-content;
  margin: 0.5em 0.5em;
}
.btn-solicitudes-estado {
  border-radius: 26.895px;
  border: 1.034px solid #C4C4C4;
  background: #FFF;
  width: 90px;
  height: 38px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btn-solicitudes-estado span {
  color: #535D66;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.4px;
  cursor: pointer;
}
.btn-solicitudes-estado-seleccionado {
  border: 1.034px solid #F2F2F2;
  background: #0855C4;
}

.btn-solicitudes-estado-seleccionado span {
  color: #FFF;
}

@media (min-width : 600px) {
  .box-card-mis-solicitudes-formatter .box-card-text-mis-solicitudes {
    width: 35em;
    height: 41em;
    margin: 0 auto;
  }
}

.btn-solicitudes-estado.disabled {
  color: #FFF;
  cursor: context-menu;
}

.btn-solicitudes-estado.disabled span {
  cursor: context-menu;
  color: #C4C4C4;
}

.btn-solicitudes-estado-seleccionado.disabled {
  border: 1.034px solid #F2F2F2;
  color: #FFF;
  background: #D4DBEA;
  cursor: context-menu;
}

.btn-solicitudes-estado-seleccionado.disabled span{
  color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/PopupMisSolicitudes.vue